(function () {
  "use strict";

  class ProductAddToCartComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const pid = this?._product?.productId || "";
      const vid = this?._product?.variantId || "";
      const handle =
        this?._product?.url?.replace("/products/", "").split("?")?.[0] || "";
      const id = `quick-buy-horizontal-sections--24504125358406__cart-drawer-${pid}-${
        Math.floor(Math.random() * 90000) + 10000
      }`;

      if (this?._product?.variants?.length > 1) {
        this.innerHTML = `
          <button type="button" class="button button--sm" aria-controls="${id}" aria-expanded="false" is="custom-button">
            <div>+ Hinzufügen</div>
            <span class="button__loader">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <quick-buy-drawer id="${id}"
            header-bordered=""
            open-from="bottom"
            handle="${handle}"
            role="dialog"
            aria-live="polite"
            class="quick-buy-drawer drawer"
            aria-modal="true">
          </quick-buy-drawer>
        `;
      } else {
        this.innerHTML = `
        <form
          method="post"
          action="/cart/add"
          id="${id}"
          accept-charset="UTF-8"
          class="shopify-product-form"
          enctype="multipart/form-data"
          is="product-form"
        >
          <input type="hidden" name="form_type" value="product" /><input
            type="hidden"
            name="utf8"
            value="✓"
          />
          <input type="hidden" name="quantity" value="1" />
          <input type="hidden" name="id" value="${vid}" />
          <button
            type="submit"
            class="button button--sm"
            is="custom-button"
          >
            <div>+ Hinzufügen</div>
            <span class="button__loader">
              <span></span>
              <span></span>
              <span></span>
            </span></button
          >
          <input type="hidden" name="product-id" value="${pid}" />
          <input
            type="hidden"
            name="section-id"
            value="sections--24504125358406__cart-drawer"
          />
        </form>
      `;
      }
    }
  }

  customElements.define("rcc-product-add-to-cart", ProductAddToCartComponent);
})();
